import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * MU-pattern properties (e.g. A078MU-MIA-02FB, B123MU-…, H456MU-…) are
 * hidden from every Property filter picker across the app.
 */
export const MU_EXCLUDE_RE = /^[ABH][0-9]{3}MU-/;
export const isMuExcluded = (nickname?: string | null): boolean =>
  !!nickname && MU_EXCLUDE_RE.test(nickname);

